import { AboutUsData } from "@modules/about-us/data/mockData";
import { trans } from "@mongez/localization";
import {
  SectionDescription,
  SectionImage,
  SectionTitle,
} from "./SectionComponents";
import { VisionMissionBG } from "./VisionMissionBG";

type VisionMissionValuesSectionProps = {
  data: AboutUsData;
};

const valuesData = [
  { key: "honesty" },
  { key: "innovation" },
  { key: "customerFocus" },
  { key: "excellence" },
  { key: "leadership" },
  { key: "sustainability" },
];

export function VisionMissionValuesSection({
  data,
}: VisionMissionValuesSectionProps) {
  return (
    <section
      id="vision-mission-section"
      className="lg:py-18 relative z-20 overflow-hidden py-10 md:py-16 xl:py-20 2xl:py-24"
    >
      <div className="absolute left-0 top-0 h-full w-full bg-marine">
        <VisionMissionBG />
      </div>
      <div className="container relative z-10 px-4 sm:px-6 lg:px-8">
        {/* Vision Section */}
        <div className="mb-16 grid items-center gap-8 sm:gap-12 md:gap-16 lg:mb-20 lg:grid-cols-2 lg:gap-20 xl:mb-28 xl:gap-32 2xl:mb-36 2xl:gap-44">
          <div className="order-2 lg:order-1">
            <SectionTitle>{trans("aboutUsPage.vision.title")}</SectionTitle>
            <SectionDescription>
              {trans("aboutUsPage.vision.description")}
            </SectionDescription>
          </div>
          <div className="order-1 lg:order-2">
            <SectionImage src={data.visionImageUrl} alt="Industrial vision" />
          </div>
        </div>

        {/* Mission Section */}
        <div className="mb-16 grid items-center gap-8 sm:gap-12 md:gap-16 lg:mb-20 lg:grid-cols-2 lg:gap-20 xl:mb-28 xl:gap-32 2xl:mb-36 2xl:gap-44">
          <div className="order-1">
            <SectionImage src={data.missionImageUrl} alt="Industrial mission" />
          </div>
          <div className="order-2">
            <SectionTitle>{trans("aboutUsPage.mission.title")}</SectionTitle>
            <SectionDescription>
              {trans("aboutUsPage.mission.description")}
            </SectionDescription>
          </div>
        </div>

        {/* Values Section */}
        <div className="grid items-center gap-8 sm:gap-12 md:gap-16 lg:grid-cols-2 lg:gap-20 xl:gap-32 2xl:gap-44">
          <div className="order-2 lg:order-1">
            <SectionTitle className="mb-6">
              {trans("aboutUsPage.values.title")}
            </SectionTitle>

            <SectionDescription>
              {trans("aboutUsPage.values.descriptionOne")}
            </SectionDescription>

            <SectionDescription>
              {trans("aboutUsPage.values.descriptionTwo")}
            </SectionDescription>

            <SectionDescription>
              {trans("aboutUsPage.values.descriptionThree")}
            </SectionDescription>

            <SectionDescription>
              {trans("aboutUsPage.values.descriptionFour")}
            </SectionDescription>

            <SectionDescription>
              {trans("aboutUsPage.values.descriptionFive")}
            </SectionDescription>

            {/* Values Grid */}
            {/* <div className="grid gap-6 sm:grid-cols-2 sm:gap-8 md:gap-9 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2">
              {valuesData.map((value, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div>
                    <div className="flex items-center gap-3">
                      <div className="bg-titanium-grey ms-2 size-1 flex-shrink-0" />
                      <h4 className="text-titanium-grey mb-1 text-lg font-bold sm:text-xl md:text-2xl">
                        {trans(`aboutUsPage.values.items.${value.key}.title`)}
                      </h4>
                    </div>
                    <p className="text-titanium-grey text-base font-light leading-relaxed sm:text-lg md:text-xl">
                      {trans(
                        `aboutUsPage.values.items.${value.key}.description`,
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </div> */}
          </div>

          <div className="order-1 lg:order-2">
            <SectionImage src={data.valuesImageUrl} alt="Industrial values" />
          </div>
        </div>
      </div>
    </section>
  );
}
